module.exports = __webpack_public_path__ + "static/media/02.5e954865.png";